import API from "./API.js";
import responseModel from "../models/Generic/responseModel";
import { handleApiError } from "./APIErrorManagement.js";

// Store clearUser callback globally so it can be called from error handler
let clearUserCallback = null;
export const setClearUserCallback = (callback) => {
  clearUserCallback = callback;
};

// Helper function to convert API response to responseModel
const convertToResponseModel = (response) => {
  if (!response) {
    return new responseModel(false, null, "No response from server");
  }

  const result = response.data;
  if (result.succeeded) {
    return new responseModel(
      true,
      result.object,
      null,
      result.additionalMessage,
      result.warnings
    );
  }

  // Handle error response
  const errors = result.Errors || result.errors || [];
  const errorMessage =
    errors.length > 0 ? errors[0].Description : "An error occurred";
  return new responseModel(false, null, errorMessage);
};

const APICall = {
  post: async function (url, model) {
    try {
      const response = await API.post(url, model, { withCredentials: true });
      return convertToResponseModel(response);
    } catch (error) {
      const errorResponse = handleApiError(error, clearUserCallback);
      const errors = errorResponse.data.Errors || [];
      return new responseModel(
        false,
        null,
        errors[0]?.Description || "An error occurred"
      );
    }
  },

  get: async function (url) {
    try {
      const response = await API.get(url, { withCredentials: true });
      return convertToResponseModel(response);
    } catch (error) {
      const errorResponse = handleApiError(error, clearUserCallback);
      const errors = errorResponse.data.Errors || [];
      return new responseModel(
        false,
        null,
        errors[0]?.Description || "An error occurred"
      );
    }
  },

  put: async function (url, model) {
    try {
      const response = await API.put(url, model, { withCredentials: true });
      return convertToResponseModel(response);
    } catch (error) {
      const errorResponse = handleApiError(error, clearUserCallback);
      const errors = errorResponse.data.Errors || [];
      return new responseModel(
        false,
        null,
        errors[0]?.Description || "An error occurred"
      );
    }
  },

  delete: async function (url) {
    try {
      const response = await API.delete(url, { withCredentials: true });
      return convertToResponseModel(response);
    } catch (error) {
      const errorResponse = handleApiError(error, clearUserCallback);
      const errors = errorResponse.data.Errors || [];
      return new responseModel(
        false,
        null,
        errors[0]?.Description || "An error occurred"
      );
    }
  },

  // External PUT for direct uploads (S3, etc.)
  putExternal: async function (url, data, headers = {}) {
    try {
      const axios = require("axios");
      const response = await axios.put(url, data, { headers });

      if (response && response.status >= 200 && response.status < 300) {
        return new responseModel(true, response.data, null);
      }
      return new responseModel(
        false,
        null,
        response?.statusText || "Upload failed"
      );
    } catch (error) {
      return new responseModel(
        false,
        null,
        error.response?.data || error.message || "Upload failed"
      );
    }
  },
};

export default APICall;
